var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPol2L(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11038 44.1713C1.60669 44.5019 0.309018 43.0807 0.77456 41.6132L13.2718 2.21812C13.7374 0.750594 15.617 0.337354 16.6551 1.47429L44.5236 31.9948C45.5618 33.1317 44.9798 34.9661 43.4762 35.2967L3.11038 44.1713Z",
    fill: "#149DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPol2L);
export default __webpack_public_path__ + "static/media/pol2l.7f1bc04c00bf59fcf2b9d449142b18d3.svg";
export { ForwardRef as ReactComponent };